export const cohortArrTableConf = [
  {
    field: 'time',
    title: 'Time'
  },
  {
    field: 'initial',
    title: 'Initial'
  },
  {
    field: 'current',
    title: 'Current'
  }
];
